import imageCompression from "browser-image-compression"
import { setImageCompressing } from "store/reducers/commonReducer"
import store from "../../store/index"
import Swal from "sweetalert2"
import i18next from "i18next"

export const handleFileChange = (
  event,
  fieldName,
  setFieldValue,
  width,
  height,
  maxSizeKB
) => {
  const fileInput = event.currentTarget
  const file = event.currentTarget.files[0]

  if (file) {
    const maxSize = maxSizeKB * 1024 // Convert KB to bytes

    // Check file size
    if (file.size > maxSize) {
      Swal.fire({
        toast: true,
        icon: "error",
        title: i18next.t(
          `File size should be less or equal to {{maxSizeKB}}KB`,
          { maxSizeKB }
        ),
        position: "top-right",
        showConfirmButton: false,
        timer: 4000,
      })
      setFieldValue(fieldName, null)
      fileInput.value = "" // Clear the input
      return
    }

    // Create an image element to check dimensions
    const img = new Image()
    img.src = URL.createObjectURL(file)

    img.onload = () => {
      // if (img.width === width && img.height === height) {
      // Check if the image is square
      if (img.width === img.height) {
        setFieldValue(fieldName, file)
      } else {
        Swal.fire({
          toast: true,
          icon: "error",
          title: i18next.t("Image should be Square Image"),
          position: "top-right",
          showConfirmButton: false,
          timer: 4000,
        })
        setFieldValue(fieldName, null)
        fileInput.value = "" // Clear the input
      }
      URL.revokeObjectURL(img.src) // Clean up object URL
    }
  } else {
    setFieldValue(fieldName, null)
    fileInput.value = ""
  }
}

// export const handleFileChange = async (event, fieldName, setFieldValue) => {
//   const file = event.currentTarget.files[0]

//   if (file) {
//     store.dispatch(setImageCompressing(true))
//     try {
//       // Options for image compression
//       const options = {
//         maxSizeMB: 0.2, // Maximum file size in MB
//         maxWidthOrHeight: 1080, // Maximum width or height
//         useWebWorker: true, // Use web workers for better performance
//       }

//       // Compress the image file
//       const compressedFile = await imageCompression(file, options)

//       // Set the compressed file value
//       setFieldValue(fieldName, compressedFile)
//       console.log("Compressed")
//     } catch (error) {
//       console.error("File compression failed:", error)
//       // Handle errors (e.g., set an error message or revert to original file)
//       setFieldValue(fieldName, file)
//     } finally {
//       store.dispatch(setImageCompressing(false)) // End compressing
//     }
//   } else {
//     setFieldValue(fieldName, null)
//   }
// }

export const getImagePreviewSrc = (mode, values) => {
  if (mode === "add") {
    if (values.imageType === "URL") {
      return values.imageUrl
    } else {
      return values.imageFile ? URL.createObjectURL(values.imageFile) : null
    }
  } else {
    // In edit mode, assume we're using the existing image URL
    // return values.imageUrl
    return null
  }
}

export const getImagePreviewSrc2 = image => {
  if (!image) return null
  // Check if image is a File object (newly uploaded)
  if (image instanceof File) {
    return URL.createObjectURL(image)
  }

  // Otherwise, assume it's an existing image URL
  return image
}

// No required
export const handleFileChange2 = (event, fieldName, setFieldValue) => {
  const file = event.currentTarget.files[0]
  if (file) {
    setFieldValue(fieldName, file)
  } else {
    setFieldValue(fieldName, null)
  }
}
// Only size required
export const handleFileChange3 = (
  event,
  fieldName,
  setFieldValue,
  maxSizeKB
) => {
  const fileInput = event.currentTarget
  const file = event.currentTarget.files[0]
  if (file) {
    const maxSize = maxSizeKB * 1024
    // Check file size
    if (file.size > maxSize) {
      Swal.fire({
        toast: true,
        icon: "error",
        title: i18next.t(
          `File size should be less or equal to {{maxSizeKB}}KB`,
          { maxSizeKB }
        ),
        position: "top-right",
        showConfirmButton: false,
        timer: 4000,
      })
      setFieldValue(fieldName, null)
      fileInput.value = "" // Clear the input
      return
    } else {
      setFieldValue(fieldName, file)
    }
  } else {
    setFieldValue(fieldName, null)
  }
}

export const handle_4_3_FileUpload = (
  event,
  setFieldValue,
  fieldName,
  isMaxSize = false,
  maxSize = null
) => {
  const file = event.target.files[0]
  if (file) {
    // Check file size in KB
    const fileSizeInKB = file.size / 1024

    if (isMaxSize && fileSizeInKB > maxSize) {
      Swal.fire({
        toast: true,
        icon: "error",
        title: i18next.t(`File size must not exceed ${maxSize} KB`),
        position: "top-right",
        showConfirmButton: false,
        timer: 4000,
      })
      event.target.value = "" // Reset the file input
      return
    }

    const img = new Image()
    img.onload = function () {
      // Check if the image has a 4:3 aspect ratio
      const aspectRatio = this.width / this.height
      if (aspectRatio.toFixed(2) === (4 / 3).toFixed(2)) {
        setFieldValue(fieldName, file)
      } else {
        Swal.fire({
          toast: true,
          icon: "error",
          title: i18next.t("Please upload an image with a 4:3 aspect ratio"),
          position: "top-right",
          showConfirmButton: false,
          timer: 4000,
        })
        event.target.value = "" // Reset the file input
      }
    }
    img.onerror = function () {
      alert("Error loading image. Please try again.")
      event.target.value = "" // Reset the file input
    }
    img.src = URL.createObjectURL(file)
  }
}
